import { AfterViewInit, Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from 'src/app/language.service';
import { NavigationLibraryService } from 'src/app/shared/services/navigation/navigation.service';

@Component({
  selector: 'app-detail-aha-gold-right-panel',
  templateUrl: './detail-aha-gold-right-panel.component.html',
  styleUrls: ['./detail-aha-gold-right-panel.component.scss'],
})
export class DetailAhaGoldRightPanelComponent implements AfterViewInit {
  @Input() labelData: string;
  label: string;
  @Input() isBackPressed: boolean = false;

  constructor(
    private readonly navigationService: NavigationLibraryService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly languageService: LanguageService
  ) {}

  ngOnInit() {
    this.label = this.languageService.getTranslatedText(this.labelData);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.focusContainer(
        'gold-upgrade-right',
        true,
        0,
        true
      );
    }, 150);
  }
}
